import React, { useEffect, useState } from "react";
import Carousel from "react-material-ui-carousel";
import "./ProductPage.scss";
import BedCustomizations from "../../Components/BedCustomizations/BedCustomizations";
import { useDispatch, useSelector } from "react-redux";
import MettressCustomizations from "../../Components/MettressCustomizations/MettressCustomizations";
import { setBedSize } from "../../Redux/BedCustomizations/BedCustomizations.actions";
import { CircularProgress } from "@material-ui/core";
import { getAProduct } from "../../api/products.api";
import { setActiveProduct } from "../../Redux/Products/Products.actions";
import { addItemToCart } from "../../Redux/Cart/cart.utils";
import { setCart } from "../../Redux/Cart/Cart.actions";
import FCustomizations from "../../Components/FCustomizations/FCustomizations";
import { setFSize } from "../../Redux/FCustomizations/FCustomizations.actions";
import { setMettressSize } from "../../Redux/MettressCustomizations/MettressCustomizations.actions";
import Reviews from "../../Components/Reviews/Reviews";

const ProductPage = ({
  match: {
    params: { catagory, id },
  },
  history,
}) => {
  const data = useSelector((state) => state.products.activeProduct);
  const drawer = useSelector((state) => state.bedCustomizations.drawer);
  const cart = useSelector((state) => state.cart.cart);
  const customs = useSelector((state) =>
    catagory === "beds"
      ? state.bedCustomizations
      : catagory === "mattress"
      ? state.mettressCustomizations
      : catagory === "furniture"
      ? state.FCustoms
      : null
  );
  const [showLoading, setShowLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const getdata = async () => {
      setShowLoading(true);
      const product = await getAProduct(id);
      dispatch(setActiveProduct(product));
      setSizes(product);
      setShowLoading(false);
    };
    getdata();
  }, []);

  const setSizes = (product) => {
    if (product.catagory === "beds") {
      dispatch(setBedSize(product.others.sizes[0]));
      return;
    }
    if (product.catagory === "mattress") {
      dispatch(setMettressSize(product.others.sizes[0]));
      return;
    }
    if (product.catagory === "furniture" && !product.others.noCustoms) {
      dispatch(setFSize(product.others.sizes[0]));
    }
  };

  const addToCart = () => {
    const item = {
      product: data,
      total: getPrice(),
      customs: {
        ...customs,
      },
    };
    const newCart = addItemToCart(dispatch, cart, item, true);
    dispatch(setCart(newCart));
  };

  const buyNow = () => {
    addToCart();
    history.push("/checkout");
  };

  const getPrice = () => {
    if (catagory === "beds" && data.others.sizes) {
      const size = data.others.sizes.filter(
        (size) => size.text === customs.size.text
      )[0];
      let price = size ? size.price : "...";

      if (customs.withMattress) {
        price =
          parseInt(price) +
          (size.mattressPrice - size.price) +
          customs.mattressType.priceToAdd;
      }
      if (customs.matchingStorageBox) {
        price = parseInt(price) + 80;
      }
      if (data.others.isDeewan) {
        price = parseInt(price) + drawer.priceToAdd;
      }

      return price;
    }

    if (catagory === "mattress") {
      const size = data.others.sizes
        ? data.others.sizes.filter((size) => size.text === customs.size.text)[0]
        : null;
      let price = size ? size.price : "...";
      price = parseInt(price) + customs.depth.priceToAdd;
      return price;
    }
    if (catagory === "furniture") {
      if (data.others.noCustoms) {
        return data.price;
      } else {
        const size = data.others.sizes
          ? data.others.sizes.filter(
              (size) => size.text === customs.size.text
            )[0]
          : null;
        let finalPrice = size ? size.price : null;
        return finalPrice;
      }
    }
  };

  return (
    <div className="ProductPage">
      {!showLoading ? (
        <div className="product-content">
          <Carousel
            interval={4000}
            stopAutoPlayOnHover={false}
            animation="slide"
            className="img"
            fullHeightHover
            autoPlay={false}
          >
            {data.images.map((image) => (
              <>
                <img src={image} alt="product" className="img" />
              </>
            ))}
          </Carousel>
          <div className="details">
            <h2>Product Details</h2>
            <p>
              <b>Name : </b>
              {data.name}
            </p>
            <p>
              <b>Availability : </b>
              {data.availability}
            </p>
            <p>
              <b>Catagory : </b>
              {data.catagory.toUpperCase()}
            </p>
            <p className="price">
              <b>&pound;{getPrice()}</b>
            </p>
            <p className="des">{data.description}</p>
          </div>

          <div className="customizations">
            {catagory === "beds" ? (
              <BedCustomizations />
            ) : catagory === "mattress" ? (
              <MettressCustomizations />
            ) : catagory === "furniture" && !data.others.noCustoms ? (
              <FCustomizations />
            ) : null}
          </div>

          <div className="bottom">
            <button onClick={addToCart} className="add-cart">
              Add To Cart
            </button>
            <button className="buy-now" onClick={buyNow}>
              {" "}
              Buy Now{" "}
            </button>
          </div>

          <Reviews id={data._id} data={data.reviews} />
        </div>
      ) : (
        <div className="loading">
          <CircularProgress size={50} color="#43444d" />
        </div>
      )}
    </div>
  );
};

export default ProductPage;
